// Superscript characters that are not supported Roboto font
export const UNSUPPORTED_SUPERSCRIPT_CHARACTERS = new Set<string>([
  'ᵃ',
  'ᵇ',
  'ᶜ',
  'ᵈ',
  'ᵉ',
  'ᶠ',
  'ᵍ',
  'ʰ',
  'ⁱ',
  'ʲ',
  'ᵏ',
  'ˡ',
  'ᵐ',
  'ᵒ',
  'ᵖ',
  'ʳ',
  'ˢ',
  'ᵗ',
  'ᵘ',
  'ᵛ',
  'ʷ',
  'ˣ',
  'ʸ',
  'ᶻ',
  'ᴬ',
  'ᴮ',
  'ᶜ',
  'ᴰ',
  'ᴱ',
  'ᶠ',
  'ᴳ',
  'ᴴ',
  'ᴵ',
  'ᴶ',
  'ᴷ',
  'ᴸ',
  'ᴹ',
  'ᴺ',
  'ᴼ',
  'ᴾ',
  'ᴿ',
  'ˢ',
  'ᵀ',
  'ᵁ',
  'ⱽ',
  'ᵂ',
  'ˣ',
  'ʸ',
  'ᶻ',
]);
